import React from 'react';

import { MenuConsumer } from '../../../FoodMenu.context';
import MenuUtil from '../../../utils/menu';
import { formatCurrency } from '../../../../../utils/currency';

const ModifierSetBasic = ({ modifierSetId }) => {
  return (
    <MenuConsumer>
      {({ modifierSets, modifiers, precision }) => {
        const modifierSet = MenuUtil.getModifierSetById(modifierSets, modifierSetId);
        const { modifiers: modifierSetModifierIds } = modifierSet;
        const modifierSetModifiers = MenuUtil.getModifierSetModifiers(
          modifierSetModifierIds,
          modifiers,
        );

        return (
          <div className="fcfm-modifier-set">
            <h6>{modifierSet.name}</h6>
            <ul>
              {modifierSetModifiers.map(({ name, price }, index) => (
                <li key={name}>
                  {name}
                  {price > 0 && `: ${formatCurrency(price, precision)}`}
                </li>
              ))}
            </ul>
          </div>
        );
      }}
    </MenuConsumer>
  );
};

export default ModifierSetBasic;
